module.exports = __webpack_public_path__ + "img/banner_topo.691ff333.jpg";